<mat-card>
  <mat-card-header>
    <mat-card-title>POS Services</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-divider></mat-divider>
    <table class="table">
      <thead>
        <tr>
          <th>Service</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        @for (service of pos_services; track service) {
          <tr>
            <td>{{ service.name }}</td>
            <td>{{ service.Status }}</td>
          </tr>
        }
      </tbody>

    </table>
  </mat-card-content>
</mat-card>